import axios from '../../client/axios'
import { ApiSaveDataParams, ApiSaveDataResponse } from './savedata.types'
import type { AxiosResponse } from 'axios'

export const assertSaveDataSucceeded = (
  response: Pick<AxiosResponse<ApiSaveDataResponse>, 'data'>
) => {
  if (!response.data.ok) throw new Error('Save data response was not ok')
}

export const apiSaveData = async ({ data, serverPath }: ApiSaveDataParams) => {
  return await axios.post<ApiSaveDataResponse>(
    `https://${serverPath}/sialdPMS/web/resourcescrossorigin/seasonmanual/savedata`,
    data
  )
}
